/* tslint:disable */

declare var Object: any;
export interface FeedServiceInterface {
  "id"?: number;
}

export class FeedService implements FeedServiceInterface {
  "id": number;
  constructor(data?: FeedServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FeedService`.
   */
  public static getModelName() {
    return "FeedService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FeedService for dynamic purposes.
  **/
  public static factory(data: FeedServiceInterface): FeedService{
    return new FeedService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FeedService',
      plural: 'FeedServices',
      path: 'FeedServices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/FeedService.ts